export const store = [];